import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

import { getProject } from "./api";
import { useFormContext } from "react-hook-form";

const PVContext = createContext();
export const usePVContext = () => useContext(PVContext);

function PVContextProvider({ children }) {
  const projectId = useParams();
  const [project, setProject] = React.useState({
    id: projectId.id,
    data: {},
  });
  const [currentTab, setCurrentTab] = React.useState(0);

  if (!project.name) {
    const func = async () => {
      const res = await getProject({ projectId: project.id });
      setProject({ ...project, ...res, data: data() });
    };
    func();
  }

  const { getValues } = useFormContext();
  const data = () => {
    if (getValues()?.revisions?.[0]) {
      const projData = getValues().revisions[0].data;
      return typeof projData === "string" ? JSON.parse(projData) : projData;
    }
  };

  React.useEffect(() => {
    const func = async () => {
      const res = await getProject({ projectId: project.id });
      setProject({ ...project, ...res, data: data() });
    };
    func();
  }, []);

  console.log({ project });

  return (
    <PVContext.Provider
      value={{
        currentTab,
        setCurrentTab,
        project,
        setProject,
      }}
    >
      {children}
    </PVContext.Provider>
  );
}

export { PVContextProvider, PVContext };
